import { useState, useEffect } from 'react';
import { Input } from 'antd';

interface DateTimeInputProps {
  value: string;
  onChange: (formatted: string) => void;
}

const DATETIME_REGEX = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

const isValidDateTime = (val: string): boolean => {
  if (!DATETIME_REGEX.test(val)) return false;
  const d = new Date(val.replace(' ', 'T'));
  return !isNaN(d.getTime());
};

export const DateTimeInput: React.FC<DateTimeInputProps> = ({ value, onChange }) => {
  const [localValue, setLocalValue] = useState(value);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setLocalValue(value);
    setHasError(false);
  }, [value]);

  const handleBlur = () => {
    if (isValidDateTime(localValue)) {
      onChange(localValue);
      setHasError(false);
    } else {
      setLocalValue(value);
      setHasError(false);
    }
  };

  return (
    <Input
      value={localValue}
      onChange={(e) => {
        setLocalValue(e.target.value);
        setHasError(e.target.value.length > 0 && !isValidDateTime(e.target.value));
      }}
      onBlur={handleBlur}
      onPressEnter={(e) => (e.target as HTMLInputElement).blur()}
      status={hasError ? 'error' : undefined}
      placeholder="YYYY-MM-DD HH:mm:ss"
      style={{ fontFamily: 'monospace', fontSize: '13px' }}
    />
  );
};
